import React from "react";
import HorizontalScrollHint from "./HorizontalScrollHint";

/**
 * Platform tab row: `tabs-list` with horizontal scroll + overflow affordance.
 * Drop-in for `<div className="tabs-list" …>`.
 */
export default function TabsList({ className = "", children, ...props }) {
  return (
    <HorizontalScrollHint
      scrollerClassName={["tabs-list", className].filter(Boolean).join(" ")}
      {...props}
    >
      {children}
    </HorizontalScrollHint>
  );
}
